import { z } from 'zod';
import { MediaItemSchema } from "../../api/media-item-schema";
import { ApiResponseSchema } from "../../api/api-response-schema";

export const ServiceSchema = z.object({
  documentId: z.string(),
  title: z.string(),
  description: z.string(),
  icon: MediaItemSchema.nullable().optional()
});

export type Service = z.infer<typeof ServiceSchema>;
const ServicePreviewArraySchema = z.array(ServiceSchema);

export type ServiceResponse = z.infer<typeof ServiceResponseSchema>;


export const ServiceResponseSchema = ApiResponseSchema(
  z.array(ServiceSchema),
);

export type ServiceSchemaKey = keyof typeof ServiceSchema.shape;

export const ServiceParams = <const>{
  populate: <ServiceSchemaKey[]>['icon'],
  fields: <ServiceSchemaKey[]>[
    'documentId',
    'title',
    'description',
  ],
};
